<template>
  <div id="main-content" class="add-class">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row style="padding-top: 30px">
          <el-col :span="11" style="display: inline">
            <el-row>
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.full_name') }}</span>
              <input class="input" v-model="notificationGroupInfo.name" type=""/>
            </el-row>
            <el-row v-if="errorMessages.name.length">
              <span v-for="(value, key) in errorMessages.name" :key="key" class="form-error"> {{ value }}</span>
            </el-row>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <el-row>
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.type') }}</span>
              <select style="" class="input" v-model="notificationGroupInfo.type">
                <option value="">{{ $t('common.please_select') }}</option>
                <option :value="USER_TYPE_SUB_DRIVER">{{ $t('common.sub_driver') }}</option>
                <option :value="USER_TYPE_PARENT">{{ $t('common.parent') }}</option>
              </select>
            </el-row>
            <el-row v-if="errorMessages.type.length">
              <span v-for="(value, key) in errorMessages.type" :key="key" class="form-error"> {{ value }}</span>
            </el-row>
          </el-col>
        </el-row>

        <div v-show="notificationGroupInfo.type === USER_TYPE_PARENT">
          <el-row class="row-section" style="padding-top: 20px; height: 70px">
            <span
              style="line-height: 40px;margin-left: 20px; font-size: 25px; font-weight: bold">{{ $t('add_parent.add_parent') }}</span>
          </el-row>
          <el-row style="padding-top: 10px">
            <el-col :span="24" style="display: inline">
              <multiselect
                v-model="selectedParent"
                :options="sortedParentList"
                :multiple="true"
                track-by="id"
                :custom-label="customParentLabel"
                :placeholder="$t('common.please_select')"
              >
              </multiselect>
            </el-col>
          </el-row>
          <el-row v-if="errorMessages.parents.length">
            <span v-for="(value, key) in errorMessages.parents" :key="key" class="form-error"> {{ value }}</span>
          </el-row>
        </div>

        <div v-show="notificationGroupInfo.type === USER_TYPE_SUB_DRIVER">
          <el-row class="row-section" style="padding-top: 20px; height: 70px">
            <span
              style="line-height: 40px;margin-left: 20px; font-size: 25px; font-weight: bold">{{ $t('sub_driver.add_sub_driver') }}</span>
          </el-row>
          <el-row style="padding-top: 10px">
            <el-col :span="24" style="display: inline">
              <multiselect
                v-model="selectedSub"
                :options="sortedSubDriverList"
                :multiple="true"
                track-by="id"
                :custom-label="customLabel"
                :placeholder="$t('common.please_select')"
              >
              </multiselect>
            </el-col>
          </el-row>
          <el-row v-if="errorMessages.sub_drivers.length">
            <span v-for="(value, key) in errorMessages.sub_drivers" :key="key" class="form-error"> {{ value }}</span>
          </el-row>
        </div>

        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'
  import Multiselect from 'vue-multiselect'
  import { clearErrorMessages, basicSort } from "@/utils"
  import { USER_TYPE_SUB_DRIVER, USER_TYPE_PARENT } from '@/config'

  export default {
    name: "EditAdminNotificationGroup",
    components: {
      PageTitle,
      Multiselect
    },
    data: function () {
      return {
        backLink: `/notification-group/detail?nid=${this.$route.query.nid}`,
        title: 'notification.edit_notification_group',
        notifcation_group_data: {
          name: "",
          type: "",
          member_ids: "",
          parents: [],
          sub_drivers: []
        },
        selectedParent: [],
        selectedSub: [],
        errorMessages: {
          name: [],
          type: [],
          parents: [],
          sub_drivers: []
        },
        USER_TYPE_SUB_DRIVER,
        USER_TYPE_PARENT,
        parentList: []
      }
    },
    methods: {
      submitAction: function () {
        let check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push({path: '/notification-group/detail', query: {nid: this.$route.query.nid}});
          };
          var selected = this.notificationGroupInfo.type === USER_TYPE_SUB_DRIVER ? this.selectedSub : this.selectedParent
          this.notificationGroupInfo.member_ids = ""
          for (const [key, value] of Object.entries(selected)) {
            this.notificationGroupInfo.member_ids += value.id + ','
          }
          this.notificationGroupInfo.member_ids = this.notificationGroupInfo.member_ids.substring(0, this.notificationGroupInfo.member_ids.length - 1)

          let payload = {
            successCallback,
            data: this.notificationGroupInfo,
            admin_notification_group_id: this.$route.query.nid
          }
          this.$store.dispatch('notificationgroup/updateNotificationGroup', payload);
        }
      },
      validate: function () {
        let check = true
        clearErrorMessages(this.errorMessages)

        if (!this.notificationGroupInfo.name.trim()) {
          check = false
          this.errorMessages.name.push('* ' + this.$t('common.name_is_required'))
        }

        if (!this.notificationGroupInfo.type) {
          check = false
          this.errorMessages.type.push('* ' + this.$t('common.type_is_required'))
        } else {
          if (this.notificationGroupInfo.type === USER_TYPE_SUB_DRIVER) {
            if (!this.selectedSub.length) {
              check = false
              this.errorMessages.sub_drivers.push('* ' + this.$t('common.sub_driver_is_required'))
            }
          } else {
            if (!this.selectedParent.length) {
              check = false
              this.errorMessages.parents.push('* ' + this.$t('common.parent_is_required'))
            }
          }
        }

        return check
      },
      customLabel(option) {
        return `${option.name} - ${option.email}`
      },
      customParentLabel (item) {
        let id = item.id.toString().split('_')
        let label = `${item.name}`

        if (item.email) {
          label += ` - ${item.email}`
        }

        if (id.length > 1) {
          label += ` (${this.$t('common.partner')})`
        }

        return label
      }
    },
    mounted: function () {
      let successCallback = () => {
        let subDriverSuccessCallback = () => {
          if (this.notificationGroupInfo.type === USER_TYPE_SUB_DRIVER) {
            let listIds = this.notificationGroupInfo.member_ids.split(',')

            listIds.forEach((id) => {
              let item = this.subDriverList.find((subDriver) => subDriver.id === parseInt(id))

              if (item) {
                this.selectedSub.push(item)
              }
            })
          }
        }

        let parentSuccessCallback = (response) => {
          this.parentList = [].concat(response.data.data.parent_list)

          if (this.notificationGroupInfo.type === USER_TYPE_PARENT) {
            let listIds = this.notificationGroupInfo.member_ids.split(',')

            listIds.forEach((id) => {
              let item = this.parentList.find((parent) => parent.id.toString() === id)

              if (item) {
                this.selectedParent.push(item)
              }
            })
          }
        }

        this.$store.dispatch('subdriver/retrieveSubDriverList', {
          successCallback: subDriverSuccessCallback
        })
        this.$store.dispatch('notification/retrieveParentList', {
          successCallback: parentSuccessCallback
        })
      }

      let payload = {
        successCallback,
        admin_notification_group_id: this.$route.query.nid
      }

      this.$store.dispatch('notificationgroup/getNotificationGroupInfo', payload)
    },
    computed: {
      ...mapState('notificationgroup', ['notificationGroupInfo']),
      ...mapState('subdriver', ['subDriverList']),
      sortedParentList: function () {
        let sortedParentList = [].concat(this.parentList)

        sortedParentList.sort((before, after) => basicSort(before, after, 'name'))

        return sortedParentList
      },
      sortedSubDriverList: function () {
        let sortedSubDriverList = [].concat(this.subDriverList)

        sortedSubDriverList.sort((before, after) => basicSort(before, after, 'name'))

        return sortedSubDriverList
      }
    }
  }
</script>

<style lang="scss">
  .edit-class .el-collapse-item__header,
  .add-class .el-collapse-item__header {
    font-size: 22px;
  }

  #drop-time select {
    width: 12%;
    float: left;
    margin-right: 25px;
    margin-left: 2px;
  }
</style>
